import { memo } from "react";
import styles from "./BaseModalV2.module.scss";
import classNames from "classnames/bind";
import cn from "classnames";
import { CloseIcon } from "~/assets/icons";

const cx = classNames.bind(styles);

type BaseModalV2Props = {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  width?: string;
  maxWidth?: string;
  title: string;
  className?: string;
};

const BaseModalV2 = (props: BaseModalV2Props) => {
  const { open, onClose, children, width, maxWidth, title, className } = props;

  if (!open) return null;

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleContainerClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
  };

  return (
    <div className={cx("base-modal-v2-overlay")} onClick={handleOverlayClick}>
      <div
        className={cn(cx("base-modal-v2-container"), className)}
        style={{ width: width, maxWidth: maxWidth }}
        onClick={handleContainerClick}
      >
        <div className={cx("header")}>
          <h4 className={cx("header-title")}>{title}</h4>

          <button className={cx("close-button")} onClick={onClose}>
            <CloseIcon className={cx("close-icon")} />
          </button>
        </div>
        <div className={cx("content")}>{children}</div>
      </div>
    </div>
  );
};

export default memo(BaseModalV2);
